// GENERATED FILE, DO NOT MANUALLY EDIT
import { HznIconChat } from './chat.js';
import { defineHorizonElement } from '@horizon/common/helpers';
import './types.js';
defineHorizonElement('hzn-icon-chat', HznIconChat);
//# sourceMappingURL=index.js.map